import { BREAKPOINTS, useMediaListener } from '@xing-com/util';

export const useScreen = () => {
  const breakpoint = useMediaListener();

  const isSmallScreen = breakpoint === BREAKPOINTS.handheld;

  return { isSmallScreen };
};
